// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".container[data-v-483417bc]{max-width:100vw;padding:0}", "",{"version":3,"sources":["/var/www/versions/20260317101651/apps/nuxt-app/layouts/flix.vue"],"names":[],"mappings":"AAiCA,4BACE,eAAA,CACA,SAAA","file":"flix.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.container{\n  max-width: 100vw;\n  padding:0px;\n}\n"]}]);
// Exports
module.exports = exports;
